module.exports = __webpack_public_path__ + "img/spinner_amarelo.92e90d23.svg";